import React, { useEffect } from 'react';

const OAuthCallbackPage = () => {
  useEffect(() => {
    console.log('[OAuth Callback] Page loaded in popup');
    
    // Check if we're in a popup window
    if (window.opener) {
      console.log('[OAuth Callback] Sending success message to main window');
      
      // Send success message to the main window
      window.opener.postMessage({
        type: 'OAUTH_SUCCESS',
        provider: 'outlook'
      }, window.location.origin);
      
      // Close the popup after a short delay
      setTimeout(() => {
        console.log('[OAuth Callback] Closing popup window');
        window.close();
      }, 500);
    } else {
      console.log('[OAuth Callback] Not in popup, redirecting to communication page');
      // If not in popup, redirect to communication page
      window.location.href = '/kommunikation';
    }
  }, []);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      backgroundColor: '#f0f0f0',
      fontFamily: 'Arial, sans-serif'
    }}>
      <div style={{ textAlign: 'center' }}>
        <h2>OAuth erfolgreich!</h2>
        <p>Das Fenster wird automatisch geschlossen...</p>
      </div>
    </div>
  );
};

export default OAuthCallbackPage;
